// extracted by mini-css-extract-plugin
export default {"gradeListTable":"gradelist_gradeListTable__VaG+E"};